class CookiesConsent {
    constructor(lang) {
        this.$cookiesLinks = $('.cookie-link');

        this._setLang(lang);
        this._init();
        this._setJobs();

        if(this.$cookiesLinks.length) {
            this._bindCookiesLinks();
        }
    }

    _init() {
        tarteaucitron.init({
            "privacyUrl": "/mentions-legales", /* Privacy policy url */

            "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
            "cookieName": "tarteaucitron", /* Cookie name */

            "orientation": "bottom", /* Banner position (top - bottom) */
            "showAlertSmall": false, /* Show the small banner on bottom right */
            "cookieslist": true, /* Show the cookie list */

            "adblocker": false, /* Show a Warning if an adblocker is detected */
            "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
            "highPrivacy": false, /* Disable auto consent */
            "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

            "removeCredit": true, /* Remove credit link */
            "moreInfoLink": false, /* Show more info link */
            "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */

            //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

            "readmoreLink": "/mentions-legales" /* Change the default readmore link */
        });
    }

    _bindCookiesLinks() {
        this.$cookiesLinks.on('click', tarteaucitron.userInterface.openPanel);
    }

    _setLang(lang) {
        /* supported: fr, en, de, es, it, pt, pl, ru */
        window.tarteaucitronForceLanguage = lang;
    }

    _setJobs() {
        // Add Google Analytics job
        tarteaucitron.user.gtagUa = 'G-RPCB6VX770';
        tarteaucitron.user.gtagMore = function () { /* add here your optionnal gtag() */ };
        (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
    }
}

export default CookiesConsent;
